import { makeVar } from '@apollo/client';
import { Bill, Transaction } from '../../types';
import { FragmentType, graphql } from '../../__generated__';
import { TransactionFormFragment } from './agent/RequestForm';

export type NewRequestState = 'input' | 'review' | 'submitted';
export type TransactionList = 'requests' | 'transactions';

export const newRequestState = makeVar<NewRequestState>('input');
export const currentRequest = makeVar<Transaction | null>(null);
export const duplicatedTransaction = makeVar<FragmentType<
  typeof TransactionFormFragment
> | null>(null);
export const refreshRequestsVar = makeVar(false);
export const billToPay = makeVar<Bill | null>(null);

export const confirmTransactionMutation = graphql(/* GraphQL */ `
  mutation ConfirmTransaction($id: ID!) {
    confirmTransaction(id: $id) {
      success
      message
      transaction {
        id
        status
      }
    }
  }
`);

export const submitTransactionMutation = graphql(/* GraphQL */ `
  mutation SubmitTransaction($id: ID!) {
    submitTransaction(id: $id) {
      success
      message
      transaction {
        id
        status
        ptn
      }
    }
  }
`);

export const cancelTransactionMutation = graphql(/* GraphQL */ `
  mutation CancelTransaction($id: ID!) {
    cancelTransaction(id: $id) {
      success
      message
      transaction {
        id
        status
      }
    }
  }
`);

export const confirmAndSubmitTransactionMutation = graphql(/* GraphQL */ `
  mutation ConfirmAndSubmitTransaction($id: ID!) {
    confirmAndSubmitTransaction(id: $id) {
      success
      message
      transaction {
        id
        status
      }
    }
  }
`);
